<div class="it-pane">
	<div class="it-panehead">
		<div class="it-panehead-left">
			<span class="it-smalllabel">Query Parameters</span>
		</div>
		<div class="it-panehead-right">
			<button class="it-toolbtn" type="button" (click)="add.emit()">Add</button>
			<button class="it-toolbtn" type="button" (click)="clear.emit()" [disabled]="request.params.length===0">Clear</button>
		</div>
	</div>

	<it-kv-editor [rows]="request.params" (updateKv)="updateKv.emit($event)" (remove)="remove.emit($event)">
	</it-kv-editor>

	<div class="it-empty" *ngIf="request.params.length===0">No query params.</div>
</div>
